import type { OrganizationMembershipResource } from '@clerk/types'
import type { AsyncStateResult } from '@saaga/shared/hooks/use-async-state.hook'
import type { ReactNode } from 'react'
import { Navigate, Outlet } from 'react-router-dom'

import { rootRoutes } from '@/routes/org-routes.const'

import { LoadingScreen } from './loading-screen.atom'

export interface OrgGuardState {
  orgLoaded: boolean
  orgListLoaded: boolean
  isMembershipsLoading: boolean
  memberships: OrganizationMembershipResource[]
  targetMembership: OrganizationMembershipResource | undefined
  currentOrgSlug: string | undefined
  targetOrgSlug: string | undefined
  orgSwitch: AsyncStateResult<void>
}

export const getOrgGuardContent = (state: OrgGuardState): ReactNode | null => {
  if (!state.orgLoaded || !state.orgListLoaded) {
    return <LoadingScreen />
  }

  if (state.isMembershipsLoading) {
    return <LoadingScreen />
  }

  if (state.memberships.length === 0) {
    return <Navigate to={`/${rootRoutes.onboarding}`} replace />
  }

  if (!state.targetMembership) {
    return getNoTargetMembershipContent(state.memberships)
  }

  if (state.currentOrgSlug === state.targetOrgSlug) {
    return <Outlet />
  }

  if (state.orgSwitch.isDone || state.orgSwitch.isError) {
    return <Outlet />
  }

  return null
}

const getNoTargetMembershipContent = (memberships: OrganizationMembershipResource[]): ReactNode => {
  const firstOrg = memberships[0]
  if (firstOrg?.organization?.slug) {
    return <Navigate to={`/${firstOrg.organization.slug}`} replace />
  }
  return <Navigate to={`/${rootRoutes.onboarding}`} replace />
}
